<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>

<div [hidden]="skelition" class="row mx-5 py-5">
  <div class="col-md-8 col-12 p-0">
    <app-no-data *ngIf="data.length <= 0 && !skelition"></app-no-data>
    <div *ngIf="data.length > 0" class="container mb-4">
      <app-table [unit]="'KNOWLEDGE_LIBRARY_CATEGORY'" [data]="data" (actionCall)="actionCall($event)"></app-table>
    </div>
  </div>

  <div *ngIf="permissionService.hasPermission('KNOWLEDGE_LIBRARY_CATEGORY','c')" class="col-md-4 col-12 p-0">
    <div class="container mb-5">
      <h2 class="text-center v4-color-white"><i style="font-size: 2rem;"
          class="pi pi-fw pi-plus-circle mx-2 v4-color-white"></i>{{"Add a new category"| translator}}</h2>
      <app-dynamic-form [questions]="questions" (sendData)="addCategory($event)"></app-dynamic-form>
      <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    </div>
  </div>
</div>

<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="1" class="mb-2"></app-skelitions>
<!-- <hr class="hr"> -->

<!-- Confirm Modal -->
<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>

<!-- Update Data Modal -->
<p-dialog [blockScroll]="true" [draggable]="false"header="Header" [(visible)]="updateModal" [style]="{ width: '50vw' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{"Interface update" | translator}}</span>
  </ng-template>
  <app-dynamic-form *ngIf="updateModal" [questions]="updateQuestions"
    (sendData)="updateCategory($event)"></app-dynamic-form>
</p-dialog>

<p-dialog [blockScroll]="true" [draggable]="false"header="Header" [(visible)]="deleteModal" [style]="{ width: '50vw' }">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">{{"Confirmation message" | translator}}</span>
  </ng-template>
  <div>
    <p>
      {{"Do you want to delete this category or do you want to move the data to another category?" | translator}}
    </p>
    <div class="d-flex gap-3 flex-row">
      <div class="flex align-items-center">
        <p-radioButton name="transferData" [value]="true" [(ngModel)]="transferData" inputId="transfer"></p-radioButton>
        <label for="transfer" class="ml-2">{{"Transfer data to another classification" | translator}}</label>
      </div>

      <div class="flex align-items-center">
        <p-radioButton name="transferData" [value]="false" [(ngModel)]="transferData"
          inputId="ingredient2"></p-radioButton>
        <label for="ingredient2" class="ml-2">{{"Delete this category and data" | translator}}</label>
      </div>
    </div>
    <div class="row mb-10" *ngIf="transferData">
      <div class="col-5 h-10">
        <p-dropdown styleClass="mt-2 w-100" appendTo="body" [(ngModel)]="changeCategory" placeholder="Select a Category"
          optionLabel="name" [options]="getFilteredCategories()">
        </p-dropdown>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-check" (click)="this.deleteCategory()" label='{{"Yes"| translator}}'></p-button>
    <p-button icon="pi pi-times" (click)="deleteModal = false" label='{{"no"| translator}}'></p-button>
  </ng-template>
  <p-messages [(value)]="deleteMessage" [enableService]="false"></p-messages>

</p-dialog>

<app-footer></app-footer>